import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

type FileSelectorReturnType = {
  buttonProps: () => {
    onClick: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  };
  inputProps: () => {
    accept: React.InputHTMLAttributes<HTMLInputElement>['accept'];
    onChange: React.InputHTMLAttributes<HTMLInputElement>['onChange'];
    ref: React.RefObject<HTMLInputElement>;
    style: React.HTMLAttributes<HTMLInputElement>['style'];
    type: 'file';
  };
  selectedFile: File | undefined;
};

type FileExtension = `.${string}`;
type FileType = `${string}/${string}`;

export function useFileSelector({
  fileOptions,
  onClick,
  onFileSelected,
}: {
  fileOptions: {
    supportedExtensions: FileExtension[];
    supportedTypes: FileType[];
  };
  onClick: () => void;
  onFileSelected: (file: File) => void;
}): FileSelectorReturnType {
  const [selectedFile, setSelectedFile] = useState<File | undefined>();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (selectedFile) {
      onFileSelected(selectedFile);
    }
  }, [selectedFile]);

  return {
    buttonProps: () => ({
      onClick: () => {
        onClick();
        inputRef.current?.click();
      },
    }),
    inputProps: () => ({
      accept: [
        ...fileOptions.supportedExtensions,
        ...fileOptions.supportedTypes,
      ].join(', '),
      onChange: () => {
        const file = inputRef.current?.files?.[0];

        if (file) {
          setSelectedFile(file);
        }
      },
      ref: inputRef,
      style: { display: 'none' },
      type: 'file',
    }),
    selectedFile,
  };
}
